<template lang="pug">
  v-dialog( v-model="active" :width="width" persistent  )
    v-card
      v-card-title.headline {{ title }}
      v-card-text.body-1 {{ message }}
      v-card-actions
        .flex-grow-1
        v-btn( depressed @click="doClose" ) {{ button }}
</template>

<script>
const VAL_TITLE = 'Message'
const VAL_BUTTON = 'Close'
const VAL_WIDTH = 300

export default {
  data () {
    return {
      active: false,
      title: VAL_TITLE,
      message: '',
      button: VAL_BUTTON,
      width: VAL_WIDTH
    }
  },
  methods: {
    doOpen ({ title, message, button, width }) {
      this.title = title || VAL_TITLE
      this.message = message || ''
      this.button = button || VAL_BUTTON
      this.width = width || VAL_WIDTH
      this.active = true
    },
    doClose () {
      this.active = false
    }
  }
}
</script>
